import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Breadcrumb,
  Nav,
  NavItem
} from 'react-bootstrap'
import { Link, browserHistory } from 'react-router'

@observer(['globals'])
export default class CompanyNavigation extends Component {
  constructor(props) {
    super(props)
  }

  handleNavSelect(e) {
    switch(e) {
      case '1':
        browserHistory.push('/company/details/' + this.props.companyId)
        break
      case '2':
        browserHistory.push('/company/invoices/' + this.props.companyId)
        break
      case '3':
        browserHistory.push('/company/createinvoice/' + this.props.companyId)
        break
      default:
        browserHistory.push('/company/details/' + this.props.companyId)
    }
  }

  render() {
    let breadcrumbText = ''
    let linkText = ''
    /*
    switch (this.props.companyStateId) {
      case 1:
        breadcrumbText = 'Contacts'
        linkText = '/contacts'
        break
      case 2:
        breadcrumbText = 'Leads'
        linkText = '/leads'
        break
      case 3:
        breadcrumbText = 'Customers'
        linkText = '/customers'
        break
      case 4:
        breadcrumbText = 'Inactive'
        linkText = 'inactive'
        break
    }
    */

    let invoicesTab = ''
    let ordersTab = ''
    let createQuoteTab = ''

    if (this.props.companyStateId == 2 || this.props.companyStateId == 3 || this.props.companyStateId == 7) { //If the company is a lead, customer or reseller
      invoicesTab = (
        <NavItem eventKey="2">Invoices</NavItem>
      )

      createQuoteTab = (
        <NavItem eventKey="3">Create Invoice</NavItem>
      )
    }
    let accessLevel = localStorage.getItem('userAccessLevel');
    return (
      <div className="">
        <div className="page-title">
          { /*}
          <div className="title_left">
            <Breadcrumb>
              <Link to="/">Home</Link> / <Link to={ linkText }>{ this.props.companyState }</Link> / { this.props.companyName }
            </Breadcrumb>
          </div>
          */ }
        </div>
        <div className="clearfix"></div>
        <Nav bsStyle="tabs" activeKey={ this.props.activeKey } onSelect={ this.handleNavSelect.bind(this) }>
          <NavItem eventKey="1">Details</NavItem>
          {accessLevel === '5' ?  null : invoicesTab }
          {accessLevel === '5' ?  null : createQuoteTab }
        </Nav>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/companynavigation.js